
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"IFRAME","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15326","data-name":"Rectangle 15326","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45597","data-name":"Group 45597"}},[_c('g',{attrs:{"id":"Group_45604","data-name":"Group 45604"}},[_c('path',{attrs:{"id":"Path_32775","data-name":"Path 32775","d":"M12.22 19.78a.75.75 0 001.061-1.061L11.561 17l1.72-1.72a.75.75 0 00-1.061-1.061l-2.25 2.25a.75.75 0 000 1.061z"}}),_c('path',{attrs:{"id":"Path_32776","data-name":"Path 32776","d":"M16.72 19.78a.75.75 0 001.061 0l2.25-2.25a.75.75 0 000-1.061l-2.25-2.25a.75.75 0 00-1.061 1.061L18.44 17l-1.72 1.719a.75.75 0 000 1.061"}}),_c('path',{attrs:{"id":"Path_32777","data-name":"Path 32777","d":"M12.758 8.25h-.008a.754.754 0 10.008 0"}}),_c('path',{attrs:{"id":"Path_32778","data-name":"Path 32778","d":"M8.258 8.25H8.25a.754.754 0 10.008 0"}}),_c('path',{attrs:{"id":"Path_32779","data-name":"Path 32779","d":"M21.75 6H8.25a3 3 0 00-3 3v12a3 3 0 003 3h13.5a3 3 0 003-3V9a3 3 0 00-3-3m1.5 15a1.5 1.5 0 01-1.5 1.5H8.25a1.5 1.5 0 01-1.5-1.5v-9h16.5zm0-10.5H6.75V9a1.5 1.5 0 011.5-1.5h13.5a1.5 1.5 0 011.5 1.5z"}}),_c('path',{attrs:{"id":"Path_32780","data-name":"Path 32780","d":"M10.508 8.25H10.5a.754.754 0 10.008 0"}})])])])
          )
        }
      }
    